import React, { useState } from 'react'
import { inject, observer } from 'mobx-react'
import TableComponent from '../../../../components/Common/TableComponent'
import { Button, Dropdown, Menu, message, Modal } from 'antd'
import {
  AlignLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import PopupEditAccountCommand from '../PopupEditAccountCommand/PopupEditAccountCommand'
import { blue, greenPrimary, redPrimary } from '../../../../color'
import { AppTable } from '../../../../components/AppTable/AppTable'
import {
  AddCircleOutlineIcon,
  MenuDotsBoldIcon,
  Pen2OutlineIcon,
  SettingsOutlineIcon,
  TrashBin2OutlineIcon,
} from '../../../../components/AppIcon'

const { confirm } = Modal

const ListAccountOfCommand = props => {
  const {
    selectedCommand,
    commandAccounts,
    onClose,
    userStore,
    accountEditStore,
    authenticationStore,
    loadingAnimationStore,
  } = props

  const { selectedUser } = userStore

  const [selectedAccount, setSelectedAccount] = useState()
  const [isVisibleEditPopup, setIsVisibleEditPopup] = useState()

  const menuButton = record => {
    return (
      <Menu>
        <Menu.Item
          key="active"
          icon={
            <SettingsOutlineIcon
              style={{ color: greenPrimary, width: 16, height: 16 }}
            />
          }
          onClick={() => {
            handleSetActive(record)
          }}>
          <span style={{ color: greenPrimary }}>Đặt làm sử dụng mặc định</span>
        </Menu.Item>

        <Menu.Item
          key="edit"
          icon={
            <Pen2OutlineIcon style={{ color: blue, width: 16, height: 16 }} />
          }
          onClick={() => handleEdit(record)}>
          <span style={{ color: blue }}>Sửa</span>
        </Menu.Item>

        <Menu.Item
          key="delete"
          icon={
            <TrashBin2OutlineIcon
              style={{ color: redPrimary, width: 16, height: 16 }}
            />
          }
          onClick={() => {
            handleDelete(record)
          }}>
          <span style={{ color: redPrimary }}>Xóa</span>
        </Menu.Item>
      </Menu>
    )
  }

  const actionColumn = {
    title: 'Tác vụ',
    width: 100,
    key: 'action',
    render: record => (
      <Dropdown overlay={menuButton(record)} trigger={['click']}>
        <Button
          title=" Thao tác"
          shape="circle"
          type="text"
          icon={
            <MenuDotsBoldIcon
              style={{ width: 20, height: 20, transform: 'rotate(90deg)' }}
            />
          }
        />
      </Dropdown>
    ),
  }

  const tableColumns = [
    {
      width: 150,
      title: 'Tên tài khoản',
      key: 'alias',
      render: record => (
        <strong style={{ textTransform: 'capitalize' }}>{record.alias}</strong>
      ),
    },
    {
      width: 150,
      title: 'Username',
      key: 'account_name',
      render: record => record.account_name,
    },
    {
      width: 150,
      title: 'Trạng thái',
      key: 'is_active',
      render: record => (record.is_active ? 'Đang sử dụng' : '--'),
    },
    actionColumn,
  ]

  const handleEdit = itemAccount => {
    setSelectedAccount(itemAccount)
    setIsVisibleEditPopup(true)
  }

  const handleSetActive = async itemAccount => {
    try {
      loadingAnimationStore.showSpinner(true)
      await accountEditStore.setActiveAccount(itemAccount.id)

      message.success('Đặt tài khoản làm sử dụng mặc định thành công')

      onEditSuccess()
    } catch (e) {
      message.error(e.vi)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleDelete = itemAccount => {
    if (!itemAccount.is_active) {
      confirm({
        title: 'Bạn có muốn xóa tài khoản này không?',
        icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
        okText: 'Đồng ý',
        cancelText: 'Không',
        okType: 'danger',
        onOk() {
          doDelete(itemAccount)
        },
      })
    } else {
      message.warning('Tài khoản này đang được sử dụng')
    }
  }

  const doDelete = async itemAccount => {
    try {
      loadingAnimationStore.showSpinner(true)
      await accountEditStore.deleteAccountById(itemAccount.id)

      message.success('Xóa tài khoản thành công')

      onEditSuccess()
    } catch (e) {
      message.error(e.vi)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleCreate = () => {
    setSelectedAccount(null)
    setIsVisibleEditPopup(true)
  }

  const onCloseEditPopup = () => {
    setIsVisibleEditPopup(false)
  }

  const onEditSuccess = () => {
    accountEditStore.getAccountsByUserCode(selectedUser.code)
  }

  return (
    <>
      <AppTable
        size="small"
        rowKey={record => record.id}
        dataSource={commandAccounts}
        columns={tableColumns}
        pagination={false}
      />

      <PopupEditAccountCommand
        selectedCommand={selectedCommand}
        selectedAccount={selectedAccount}
        isVisibleEditPopup={isVisibleEditPopup}
        onClose={onCloseEditPopup}
        onEditSuccess={onEditSuccess}
      />

      <Button
        className="custom-ant-button w-160 icon-btn"
        style={{ marginTop: 24 }}
        onClick={handleCreate}
        icon={<AddCircleOutlineIcon style={{ width: 18, height: 18 }} />}>
        Tạo mới tài khoản
      </Button>
    </>
  )
}

ListAccountOfCommand.propTypes = {}

export default inject(
  'userStore',
  'authenticationStore',
  'loadingAnimationStore',
  'commandStore',
  'accountEditStore'
)(observer(ListAccountOfCommand))
